module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-17.64e82c79.png";